import http from '@/core/http'
// eslint-disable-next-line
import { map } from 'lodash'


const state = {
  itens: [],
}

const actions = {
  getItens: async ({ commit }, payload) => {
    const result = await http.get('liquidacao-financeira', { params: payload })
    commit('LISTA_ITENS', result.data.data)
    return Promise.resolve(result)
  },

  fecharLiquidacaoMensal: async ({ commit }, payload) => {
    const result = await http.post('liquidacao-financeira', payload)
    commit('LISTA_ITENS', result.data.data)
    return Promise.resolve(result)
  },

  limparTabela: ({ commit }) => {
    commit('LIMPAR_ITEM')
  }
}

const mutations = {
  'LISTA_ITENS' (state, payload) {
    state.itens = payload
    // state.totalItens = payload.totalItens
  },

  'LIMPAR_ITEM' (state) {
    state.itens = []
  }
}

const getters = {
  listaItens: state => state.itens
}

export default { namespaced: true, state, actions, mutations, getters }